<script setup lang="ts">
withDefaults(
  defineProps<{
    selected?: boolean;
    title?: string;
    subtitle?: string;
    mini?: boolean;
    extended?: boolean;
  }>(),
  {
    mini: false,
    extended: false,
  }
);
</script>

<template>
  <div
    :class="{ 'selected-item ': selected }"
    class="rounded tile overflow-hidden"
  >
    <div
      class="d-flex flex-row gap-2 p-3 align-items-center hoverable-card cursor-pointer"
    >
      <div class="col d-flex flex-row gap-3 align-items-center text-truncate">
        <slot name="icon"></slot>

        <div class="col text-truncate">
          <div class="row w-100 h-100 text-truncate">
            <div class="col-12 text-truncate">
              <div v-if="title" class="col-12 text-truncate">
                {{ title }}
              </div>
              <slot name="title"></slot>
            </div>
            <div
              class="mt-1 col-12 d-flex flex-wrap text-grey align-items-center gap-2"
              style="font-size: 10px"
            >
              <slot name="subtitle">
                <div v-if="subtitle" class="col-12 me-2 text-grey">
                  {{ subtitle }}
                </div></slot
              >

              <slot name="more"></slot>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto d-flex align-items-center relative-position gap-2">
        <slot name="actions"></slot>
      </div>
    </div>
    <div v-if="extended" class="border-top">
      <slot name="extended"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tile {
  background-color: var(--bs-white);
  border: 1px solid var(--bs-border-color);
}
</style>
